import { useState } from "react";
import MainLayout from "../../components/layout/layout";

import { BodyBlock, LightText } from "./sign-in";
import {
  LabelText,
  LargeHeadline,
  MediumText,
  SubTitle,
} from "../../components/typography";
import { Button } from "../../components/ui/button";
import { COLORS } from "../../assets/utils/enums/colors";
import EnterCode from "../../components/ui/enter-code";
import { useAuthValidation } from "../../assets/utils/hooks/useAuthValidation";
import { AuthModeEnum } from "../../assets/utils/validation/types";
import toast from "react-hot-toast";
import CustomToast from "../../components/ui/custom-toast";
import { ToastTypeEnum } from "../../assets/utils/enums/toast";
import { useDispatch } from "react-redux";
import { API_URL_AUTH } from "../../constants";
import { useNavigate } from "react-router-dom";
import { store } from "../../assets/store";
import { setConfirmCode } from "../../assets/store/confirm-code";

export default function EnterVerificationCode() {
  const [loaderState, setLoaderState] = useState<boolean>(false);
  const [code, setCode] = useState<string>("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { errors, validate } = useAuthValidation();

  async function enterVerificationCode() {
    try {
      setLoaderState(true);
      const { hasErrors } = validate({ code }, AuthModeEnum.CODE);
      if (hasErrors) return;

      const response = await fetch(`${API_URL_AUTH}/verify-reset-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: store.getState().resetPassword.email,
          code: code,
        }),
        credentials: "include",
      });
      
      if (!response.ok) {
        const text = await response.text();
        toast((t) => (
          <CustomToast
            t={t}
            type={ToastTypeEnum.ERROR}
            text={
              text.split("\n")[0].split("System.Exception:")[1]?.trim() ||
              "Помилка вводу"
            }
          />
        ));
        return;
      }
      dispatch(setConfirmCode(code));
      navigate("/reset-password");
    } catch (error) {
      console.error("Fetch error:", error);
      toast((t) => (
        <CustomToast
          t={t}
          text={"Упс, щось пішло не так\nПроблема з сервером."}
          type={ToastTypeEnum.ERROR}
        />
      ));
    } finally {
      setTimeout(() => {
        setLoaderState(false);
      }, 1000);
    }
  }

  return (
    <MainLayout
      className="d-flex flex-column align-items-center"
      loaderState={loaderState}
    >
      <BodyBlock>
        <LargeHeadline>Введіть код підтвердження</LargeHeadline>
        <SubTitle>
          Будь ласка, введіть 4-значний код, надісланий на вашу електронну
          адресу.
        </SubTitle>
        <EnterCode
          callback={setCode}
          isLoading={loaderState}
          errorText={errors?.code}
        />
        <Button
          bgcolor={COLORS.blue}
          txtcolor={COLORS.white}
          brcolor={"transparent"}
          width="100%"
          type="large"
          onClick={enterVerificationCode}
        >
          <LabelText>Перевірити та продовжити</LabelText>
        </Button>
        <span className="d-flex align-items-center pt-1 cursor-pointer">
          <LightText>Не отримали код?</LightText>
          <Button
            bgcolor={"transparent"}
            txtcolor={COLORS.blue}
            type="large"
            brcolor={"transparent"}
            width="auto"
          >
            <MediumText>Надіслати знову</MediumText>
          </Button>
        </span>
      </BodyBlock>
    </MainLayout>
  );
}
